import { theme } from '@prophecy/theme';
export const tokens = {
    colorShades: {
        light: {
            outerLayer: 100,
            innerLayer: 0
        },
        dark: {
            outerLayer: 600,
            innerLayer: 0
        },
        gradient: {
            outerLayer: 50,
            innerLayer: 600
        },
        lightGradient: {
            outerLayer: 50,
            innerLayer: 100
        },
        modern: {
            outerLayer: 0,
            innerLayer: 0
        }
    },
    IconSize: {
        s: {
            iconSize: {
                default: theme.sizes.x16,
                gradient: theme.sizes.x14
            },
            innerLayerSize: theme.sizes.x24,
            backgroundLayerSize: theme.sizes.x32
        },
        m: {
            iconSize: {
                default: theme.sizes.x20,
                gradient: theme.sizes.x16
            },
            innerLayerSize: theme.sizes.x28,
            backgroundLayerSize: theme.sizes.x40
        },
        l: {
            iconSize: {
                default: theme.sizes.x24,
                gradient: theme.sizes.x20
            },
            innerLayerSize: theme.sizes.x32,
            backgroundLayerSize: theme.sizes.x48
        },
        xl: {
            iconSize: {
                default: theme.sizes.x28,
                gradient: theme.sizes.x20
            },
            innerLayerSize: theme.sizes.x36,
            backgroundLayerSize: theme.sizes.x56
        }
    }
};
